module.exports = __webpack_public_path__ + "static/media/webdesign-services-img32.ebc5cf0f.jpg";